export default __webpack_public_path__ + "static/media/ssn-logo.b53583f9.svg";